import {inject, Injectable} from '@angular/core';
import {child, get, Database, ref, set} from 'firebase/database';
import {FirebaseInitService} from '../shared/firebase-init.service';
import {Profile, Setting} from '@models';
import {logger} from '../shared';

@Injectable()
export class SettingsService {

	private readonly firebaseInit = inject(FirebaseInitService);

	private get database(): Database {
		return this.firebaseInit.database;
	}

	async getSettings(user: Profile) {
		const settingsRef = child(ref(this.database), `settings/${user.uuid}`);
		const settings: Setting = new Setting();
		settings.email = user.email;
		return get(settingsRef).then((snapshot) => {
			if (snapshot.exists()) {
				const dbSettings = snapshot.val();
				settings.setLang(dbSettings.shortCodeLang);
				settings.onlyOneMailADay = dbSettings.onlyOneMailADay;
				settings.sendMailForNewMessage = dbSettings.sendMailForNewMessage;
				return settings;
			} else {
				return settings;
			}
		}).catch((error) => {
			logger.error(error);
			return settings;
		});
	}

	async setSettings(user: Profile, setting: Setting) {
		const settingsRef = child(ref(this.database), `settings/${user.uuid}`);
		return set(settingsRef, {
			onlyOneMailADay: setting.onlyOneMailADay,
			sendMailForNewMessage: setting.sendMailForNewMessage,
			shortCodeLang: setting.currentLanguage.shortCode
		});
	}
}
